import { type IconString } from '2-core-elements/Icon/DuotoneIcon';
import type { MapItem } from './MapTypes';


export type IconLists = IconString;

export interface GoogleMapPinProps {
    // eslint-disable-next-line react/no-unused-prop-types
    lat?: number;
    // eslint-disable-next-line react/no-unused-prop-types
    lng?: number;
    style?: React.CSSProperties;
}


export const filterItemsById = (
    items: MapItem[],
    activeItemId: string
): MapItem[] => {
    return items.filter(({ id }) => {
        return id === activeItemId;
    });
};

export const iconLists = {
    Airports: 'airport-01',
    GasElectric: 'electricity',
    GasProcessing: 'gas-01',
    RenewableNaturalGas: 'gas-01',
    Government: 'government',
    HeatingCooling: 'pipeline-02',
    Renewables: 'wind-power-01',
    Seaports: 'seaport-04',
    Road: 'road-01',
    WaterWastewater: 'water-01',
    Pipelines: 'pipeline-01',
    EnergyStorage: 'solar-power-02',
    Diversified: 'diversity',
    DataStorage: 'data-01',
    Education: 'education',
    AgedCare: 'healthcare',
    PublicTransport: 'rail',
    Telecommunications: 'digital',
    AirportServices: 'trolley',
    // real estate icon
    SocialInfrastructure: 'social-infrastructure',
    Retail: 'retail',
    Office: 'office-asset',
    MixedUse: 'mixed-use',
    Industrial: 'industrial',
    Living: 'housing-living',
    Healthcare: 'healthcare',
};


// based on figma: https://www.figma.com/file/8yYdqJ3M4sx6j5pBWSMl2A/IFM-Design-System?type=design&node-id=25500-176908&t=IsIKj1ThA6oWQDge-0
// it seems like it's sector dependant for now.
export const getIconByCategory = (iconKey: string): IconLists => {
    // default if not found
    if (!iconKey || !iconLists[iconKey as keyof typeof iconLists]) {
        return 'healthcare';
    }

    return iconLists[iconKey as keyof typeof iconLists] as IconString;
};
